import { render, staticRenderFns } from "./WsDataTablePagenateTypeB.vue?vue&type=template&id=07a1e0b2&"
import script from "./WsDataTablePagenateTypeB.vue?vue&type=script&lang=js&"
export * from "./WsDataTablePagenateTypeB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports